import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const MaskedLines = ({ lines, className = "", lineClass = "", delay = 0.2, inView = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass} ${line.className || ""}`}
          initial={{ y: "110%" }}
          {...(inView
            ? { whileInView: { y: "0%" }, viewport: { once: true, amount: 0.1 } }
            : { animate: { y: "0%" } })}
          transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}
        >
          {line.text}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37] ${className}`}>
    <span className="h-px w-8 bg-[#D4AF37]/60" />
    {children}
  </p>
);
